export class HttpError extends Error {
  public readonly response: Response;

  constructor(response: Response) {
    super(`HTTP ${response.status} ${response.statusText}`);

    this.name = 'HttpError';
    this.response = response.clone();
  }
}
